import {
    EMAIL_IN_USE_ERROR_TYPE,
    getTimeZoneOptions,
    MAX_INPUT_FIELD_LENGTH,
} from '@/entities/client';
import { EmailPhoneFields } from '@/shared/ui/forms/email-phone-fields';
import { ProfileFormSection } from '@/shared/ui/forms/profile-form-section';
import { TimeZoneField } from '@/shared/ui/forms/time-zone-field';

const TIME_ZONE_OPTIONS = getTimeZoneOptions();

export function EditClientProfileFormContact() {
    return (
        <ProfileFormSection title="Contact information">
            <EmailPhoneFields
                maxLength={MAX_INPUT_FIELD_LENGTH}
                revalidateOnErrorType={EMAIL_IN_USE_ERROR_TYPE}
            />
            <TimeZoneField options={TIME_ZONE_OPTIONS} />
        </ProfileFormSection>
    );
}
